import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXDatePicker from "../../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";

const ServiceValuationFormStepFour = (props) => {
  const { t } = useTranslation();

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col className="d-flex align-items-center">
          <Field
            className="mb-4"
            name="quoteValidUntil"
            label={`${t("global:servicevaluation.quoteValidUntil")}`}
            component={BMXDatePicker}
            data-cy="quoteValidUntil"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={5}>
          <Field
            className="mb-1"
            name="additionalQuoteContent"
            data-cy="additionalQuoteContent"
            component={BMXTextField}
            label={t("global:servicevaluation.additionalQuoteContent")}
          />
        </Col>
      </Row>
      <Row>
        <Col style={{ bottom: 0, position: "absolute" }}>
          <Field
            name="quoteComments"
            data-cy="quoteComments"
            component={BMXTextField}
            label={t("global:servicevaluation.quoteComments")}
          />
        </Col>
      </Row>
    </div >
  );
};

export default ServiceValuationFormStepFour;
